<section class="client-notification-card" *ngIf="header.title else notify_component_not_loaded">

    <div>
        <h1 class="title">{{ header.title }}</h1>
        <p class="subtitle">{{ header.subtitle }}</p>
    </div>

    <div fxLayoutAlign="space-between center">
        <mat-radio-group name="notify-client-option">
            <mat-radio-button 
                *ngFor="let option of notify_types_options"
                [value]="option.value"
                (click)="optionSelected(option.value)"
            >
                {{ sendMethodText }} {{ option.alias }}
            </mat-radio-button>
        </mat-radio-group>
        <button [disabled]="!notifyValueSelected" mat-button color="accent" (click)="emitNotifyMethod()">{{sendBtnText}}</button>
    </div>
</section>

<ng-template #notify_component_not_loaded>
    <p>Loading component...</p>
</ng-template>